// decorators.ts

// Debounce
export function debounce(wait: number) {
    const timeouts = new WeakMap<any, any>();
  
    return function (
      target: any,
      propertyKey: string,
      descriptor: PropertyDescriptor
    ) {
      const originalMethod = descriptor.value;
  
      descriptor.value = function (...args: any[]) {
        const self = this;
  
        if (timeouts.has(self)) {
          clearTimeout(timeouts.get(self));
        }
  
        const timeout = setTimeout(() => {
          originalMethod.apply(self, args);
        }, wait);
  
        timeouts.set(self, timeout);
      };
  
      return descriptor;
    };
  }
  
  // Throttle
  export function throttle(limit: number) {
    const throttles = new WeakMap<any, boolean>();
  
    return function (
      target: any,
      propertyKey: string,
      descriptor: PropertyDescriptor
    ) {
      const originalMethod = descriptor.value;
  
      descriptor.value = function (...args: any[]) {
        const self = this;
  
        if (throttles.get(self)) return;
  
        throttles.set(self, true);
        originalMethod.apply(self, args);
  
        setTimeout(() => {
          throttles.set(self, false);
        }, limit);
      };
  
      return descriptor;
    };
  }
  
  // Memoize
  export function memoize(
    target: any,
    propertyKey: string,
    descriptor: PropertyDescriptor
  ) {
    const cache = new Map<string, any>();
    const originalMethod = descriptor.value;
  
    descriptor.value = function (...args: any[]) {
      const key = JSON.stringify(args);
      if (cache.has(key)) {
        return cache.get(key);
      }
      const result = originalMethod.apply(this, args);
      cache.set(key, result);
      return result;
    };
  
    return descriptor;
  }
  